import { RpcError } from "grpc-web";
import { UpdateTrackPositionRequest, UpdateTrackPositionResponse } from "../proto/api_pb";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { backOff } from "exponential-backoff";

export const UpdateTrackPosition = async (
    token: string,
    userId: string,
    trackId: string,
    position: number,
    enterpriseId?: string
): Promise<RpcError | UpdateTrackPositionResponse | undefined> => {
    try {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new UpdateTrackPositionRequest();
        request.setUserId(userId);
        request.setTrackId(trackId);
        request.setPosition(position)
        if (enterpriseId) request.setEnterpriseId(enterpriseId)
        const metadata = {
            Authorization: `${token}`,
            "Access-Control-Allow-Origin": "*",
        };
        return await backOff(
            () =>
                new Promise<UpdateTrackPositionResponse | RpcError>((resolve, reject) => {
                    ommuseClient.updateTrackPosition(
                        request,
                        metadata,
                        function (err, response) {
                            if (err) {
                                reject(err);
                            } else {
                                resolve(response);
                            }
                        }
                    );
                }),
            {
                numOfAttempts: 3,
                jitter: "full",
            }
        );
    } catch (e) {
        console.log(e);
    }
};